import { render, staticRenderFns } from "./IconNext.vue?vue&type=template&id=304da3ea&scoped=true"
var script = {}
import style0 from "./IconNext.vue?vue&type=style&index=0&id=304da3ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "304da3ea",
  null
  
)

export default component.exports